import { useState, useContext } from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useDataTableHandle } from '../DataTable';
import Toast from '../Toast/Toast';
import isoDateConverter from '../isoDateConverter';
import { ShowIf } from '../Security/security';
import { StoreContext } from '../Store';
import OrderFormTable from './OrderFormTable';
import OrderFormUpload from './OrderFormUpload';
import { PostOrderFormsMasterDataSearch } from '../apiCalls';
import { useDataTableData } from '../../hooks/useDataTableData';

const OrderFormMasterData = () => {
  const [paginationLoaded, setPaginationLoaded] = useState(false);
  const [refreshData, setRefreshData] = useState({});
  const [showToast, setShowToast] = useState(false);
  const store = useContext(StoreContext);

  const [newOrderForm, setNewOrderForm] = useState(null);

  async function updateData(setPaginationLength, pagination, sortStatus, search, filter) {
    setRefreshData({
      pagination,
      sortStatus,
      search,
      filter,
      setPaginationLength,
    });
  }

  const toastContent = () => {
    return (
      <Toast className="error-toast">
        <Alert style={{ maxWidth: '35rem', backgroundColor: '#E4E3ED' }} show={showToast}>
          <button className="btn-close position-absolute top-0 end-0 p-3" onClick={() => setShowToast(false)} />
          <div className="floating-box-header-newload align-items-center" style={{ margin: '0px 30px', padding: 0 }}>
            <span>{showToast?.toastTitle}</span>
          </div>
          <p style={{ fontSize: '100%', fontWeight: 500 }} className="text-danger">
            {showToast?.toastBody}
          </p>
        </Alert>
      </Toast>
    );
  };

  const dth = useDataTableHandle();

  const { data, lastUpdated } = useDataTableData(dth, refreshData, PostOrderFormsMasterDataSearch, paginationLoaded);

  return (
    <Container className="container-xl" style={{ maxWidth: '1600px' }}>
      {toastContent()}
      <section className="floating-box" style={{ maxWidth: '1600px' }}>
        {newOrderForm === null ? (
          <OrderFormTable
            dth={dth}
            data={data}
            updateData={updateData}
            setPaginationLoaded={setPaginationLoaded}
            persist={store.orderFormMasterDataPersist[0]}
            setPersist={store.orderFormMasterDataPersist[1]}
            setNewOrderForm={setNewOrderForm}
            lastUpdated={isoDateConverter(lastUpdated)}
          />
        ) : (
          <ShowIf
            or={[
              { department: 'OPS', role: 'SUPERUSER' },
              { department: 'QA', role: 'SUPERUSER' },
              { department: 'CMT' },
            ]}
          >
            <OrderFormUpload
              setNewOrderForm={setNewOrderForm}
              dthProducts={dth}
              setShowToast={setShowToast}
              setRefreshProductsData={updateData}
              lastUpdated={isoDateConverter(lastUpdated)}
            />
          </ShowIf>
        )}
      </section>
    </Container>
  );
};

export default OrderFormMasterData;
